import { useEffect, useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import i18n from "@lang/i18n";
import questions from "@data/questions.json";

const Questions = ({ t, step, show, handleClose }) => {
  const currentLanguage = i18n.language;
  const [product, setProduct] = useState("");

  useEffect(() => {
    const savedProduct = localStorage.getItem("product");
    if (savedProduct) {
      setProduct(savedProduct);
    }
  }, [currentLanguage, product, step]);

  const currentData = questions?.[product];

  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{t("your_questions")}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="my-3 px-3">
            {currentData ? (
              <Row>
                {currentData.map((data, index) => (
                  <Col key={index} xs="12" sm="12" md="12" className="my-2">
                    <div className="fs-5 fw-bold">
                      {data?.[currentLanguage]?.question}
                    </div>
                    <p
                      className="mt-3 fs-6 text-secondary"
                      dangerouslySetInnerHTML={{
                        __html: data?.[currentLanguage]?.answer,
                      }}
                    ></p>
                  </Col>
                ))}
              </Row>
            ) : (
              <p>{t("no_data_available")}</p>
            )}
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Questions;
